import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-components/loadhandlers/Loadable';
import { pointsScannerEnabled } from 'utils/constants';

const SuperAdminPanel = Loadable(lazy(() => import('views/admin/admin-dashboard/SuperAdminPanel')));
const UserAnalytics = Loadable(lazy(() => import('views/admin/user-analytics/UserAnalytics')));
const InfluencerAnalytics = Loadable(lazy(() => import('views/admin/influencer-analytics/InfluencerAnalytics')));
const CreatorAnalytics = Loadable(lazy(() => import('views/admin/creator-analytics/CreatorAnalytics')));

const MyApps = Loadable(lazy(() => import('views/my-apps/index')));
const Subscription = Loadable(lazy(() => import('views/subscription/SubscriptionPage')));

const Deals = Loadable(lazy(() => import('views/Deals')));
const Profile = Loadable(lazy(() => import('views/profile/Profile')));

const NotificationSettings = Loadable(lazy(() => import('views/notification-settings/NotificationSettings')));
const Referral = Loadable(lazy(() => import('views/referral/Referral')));
const PointsPortal = Loadable(lazy(() => import('views/points/PointsPortal')));
const PointsScannerUnavailable = Loadable(lazy(() => import('views/points/PointsScannerUnavailable')));

const ItineraryAIForm = Loadable(lazy(() => import('views/ItineraryAIForm')));
const ItineraryAIFinalPlan = Loadable(lazy(() => import('views/ItineraryAIFinalPlan')));
const ItineraryAIFinalPlanEditor = Loadable(lazy(() => import('views/ai-trip-plan-editor/AITripPlanEditor')));

const AiTripPlans = Loadable(lazy(() => import('views/ai-trip-plans/index')));

const InfluencerDashboard = Loadable(lazy(() => import('views/influencer/Influencer')));
const StripeConnectOnboarding = Loadable(lazy(() => import('views/influencer/stripe-connect/StripeConnectOnboarding')));
const StripeConnectBalances = Loadable(lazy(() => import('views/influencer/stripe-connect/StripeConnectBalances')));
const StreamView = Loadable(lazy(() => import('views/stream/StreamView')));
const MyCollection = Loadable(lazy(() => import('views/collection/index')));
const SalesDashboard = Loadable(lazy(() => import('views/sales-dashboard/index')));

const roleRoutes = (routes) =>
  ['influencer', 'creator'].flatMap((role) => routes.map((route) => ({ ...route, path: `${role}/${route.path}` })));

const UserRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: 'my-apps',
      element: <MyApps />
    },
    {
      path: 'collection',
      element: <MyCollection />
    },
    {
      path: 'subscription',
      element: <Subscription />
    },
    {
      path: 'flight-deal-scanner',
      element: <Deals />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: 'notification-settings',
      element: <NotificationSettings />
    },
    {
      path: 'ai-trip-plans',
      element: <AiTripPlans />
    },
    {
      path: 'itinerary-ai',
      element: <ItineraryAIForm />
    },
    {
      path: 'itinerary-ai-plan',
      element: <ItineraryAIFinalPlan />
    },
    {
      path: 'itinerary-ai-plan-editor',
      element: <ItineraryAIFinalPlanEditor />
    },
    {
      path: 'referral',
      element: <Referral />
    },
    {
      path: 'points',
      element: pointsScannerEnabled ? <PointsPortal /> : <PointsScannerUnavailable />
    },
    ...roleRoutes([
      { path: ':childpath', element: <InfluencerDashboard /> },
      { path: 'invite-a-user', element: <Referral /> },
      { path: 'stripe-connect-onboarding', element: <StripeConnectOnboarding /> },
      { path: 'stripe-connect/balances', element: <StripeConnectBalances /> },
      { path: 'spotlight', element: <StreamView /> },
      { path: 'sales-dashboard', element: <SalesDashboard /> }
    ]),
    {
      path: 'admin/super-admin',
      element: <SuperAdminPanel />
    },
    {
      path: 'admin/user-analytics',
      element: <UserAnalytics />
    },
    {
      path: 'admin/influencer-analytics',
      element: <InfluencerAnalytics />
    },
    {
      path: 'admin/creator-analytics',
      element: <CreatorAnalytics />
    },
    {
      path: 'stream',
      element: <StreamView />
    }
  ]
};

export default UserRoutes;
